var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('div',{staticClass:"col-md-12 home-box"},[_c('Breadcrumbs',{attrs:{"title":'Projects'}}),_c('ProjectGrid')],1),_c('div',{staticClass:"col-md-12 home-tabs-body"})])}
var staticRenderFns = []

export { render, staticRenderFns }